import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";

const AddAccessRight = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [accessRights, setAccessRights] = useState([]);
  const [entries, setEntries] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [checkedRights, setCheckedRights] = useState([]);

  const fetchAccessRights = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefix}getAccessRightsItem`);
      if (response.data.status === "ok") {
        setAccessRights(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch access rights:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefix}api/getAllUsers`);
      if (response.data.status === "ok") {
        setEntries(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch users:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccessRights();
    fetchUserData();
  }, []);

  useEffect(() => {
    const selectedUser = entries.find(
      (user) => user.user_id.toString() === selectedId
    );
    if (selectedUser) {
      const rights =
        typeof selectedUser.access_rights === "string"
          ? selectedUser.access_rights.split(",")
          : Array.isArray(selectedUser.access_rights)
          ? selectedUser.access_rights
          : [];

      setCheckedRights(rights);
    } else {
      setCheckedRights([]);
    }
  }, [selectedId, entries]);

  const handleCheckboxChange = (right) => {
    const updatedRights = checkedRights.includes(right)
      ? checkedRights.filter((r) => r !== right)
      : [...checkedRights, right];

    setCheckedRights(updatedRights);
  };

  const handleClear = () => {
    setCheckedRights([]);
    setSelectedId("");
  };

  const handleSubmit = async () => {
    const AccessRightData = {
      userId: selectedId,
      accessRights: checkedRights,
    };

    try {
      const response = await fetch(`${urlPrefix}update/access-rights`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(AccessRightData),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to upload data. HTTP status: ${response.status}`
        );
      }

      toast.success("Upload successful");
      handleClear();
    } catch (error) {
      console.error("Error submitting access rights:", error);
      toast.error("Failed to upload data. Please try again.");
    }
  };

  return (
    <div className="d-flex justify-content-center">
      <div className="papaDiv w-50">
        <h5 className="bg-dark text-white text-center p-2">Add Access Right</h5>

        <div className="mb-3 text-center">
          <select
            className="form-select text-black fw-bolder text-center mt-4 form-control"
            onChange={(e) => setSelectedId(e.target.value)}
            value={selectedId}
          >
            <option value="">Select User Name</option>
            {entries.map((item) => (
              <option key={item.user_id} value={item.user_id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        {!selectedId ? (
          <div className="mt-3 p-2 bg-info text-center">
            Please select a user to load access rights.
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="table-dark text-center align-middle sticky-top">
                <tr>
                  <th>Access Right</th>
                </tr>
              </thead>
              <tbody>
                {accessRights.map((item) => (
                  <tr key={item.access_right_name}>
                    <td className="d-flex align-items-center">
                      <input
                        className="m-2 form-check-input"
                        style={{ transform: "scale(1.5)", marginRight: "10px" }}
                        type="checkbox"
                        checked={checkedRights.includes(item.access_right_name)}
                        onChange={() =>
                          handleCheckboxChange(item.access_right_name)
                        }
                      />
                      {item.access_right_name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="text-center mt-4">
          <button
            className="btn btn-outline-success m-2 px-5"
            onClick={handleSubmit}
            disabled={!selectedId}
          >
            Upload
          </button>
          <button
            className="btn btn-outline-secondary m-2 px-5"
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAccessRight;
